import React from 'react';
import { Leaf } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-cream pt-20 pb-16 md:pt-28 md:pb-24 overflow-hidden" data-id="element-71">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-72">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-sage-light rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-73"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-74"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-75">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-76">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-77">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-light text-sage-dark text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-78">
              <Leaf size={16} className="text-sage" data-id="element-79" />
              <span data-id="element-80">Para mujeres de 55+</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" data-id="element-81">
              Recupera tu Libertad de Movimiento
            </h1>

            <p className="text-xl md:text-2xl font-heading italic text-sage mb-6" data-id="element-82">
              El Método de 10 Minutos para una Vida sin Rigidez
            </p>

            <p className="text-lg text-text-muted mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-83">
              Diseñado exclusivamente para mujeres de 55+ que desean aliviar el
              dolor articular y recuperar su agilidad sin salir de casa.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-84">
              <a href="#pricing-cta" className="inline-block w-full sm:w-auto px-8 py-4 bg-gold hover:bg-[#b39154] text-white font-bold text-lg rounded-full shadow-soft transition-all transform hover:-translate-y-1 text-center" data-id="element-85">
                ¡SÍ, QUIERO RECUPERAR MI MOVILIDAD!
              </a>
              <p className="text-sm text-text-muted flex items-center gap-2" data-id="element-86">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-87"></span>
                Acceso inmediato tras tu compra segura
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-none relative" data-id="element-88">
            <div className="absolute inset-0 bg-sage-light rounded-[2.5rem] transform rotate-3 scale-105 opacity-50" data-id="element-89"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6fTEZca188hJtU6J1KVC8G/liberacion_de_movimiento.png" alt="Guía Liberación de Movimiento en una tablet" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl object-cover" data-id="element-90" />
          </div>
        </div>
      </div>
    </section>;
}